module.exports = __webpack_public_path__ + "static/media/game2.ea210059.png";